import { Action, ActionReducer } from '@ngrx/store';
import { List } from 'immutable';
import * as Pubnub from 'pubnub';
import * as PubnubActions from './pubnub-store.actions';
import { PubnubStoreState } from './pubnub-store.model';

export function reducer(
  state: PubnubStoreState = new PubnubStoreState(),
  action: PubnubActions.All,
) {
  switch (action.type) {
    case PubnubActions.MESSAGE_RECEIVED: {
      return state.withMutations((s) => {
        s.message = action.message;
      });
    }
    case PubnubActions.STATUS_CHANGE: {
      return state.withMutations((s) => {
        const status = action.status;
        s.status = status;
        switch (status.category) {
          case Pubnub.CATEGORIES.PNConnectedCategory: {
            if (status.subscribedChannels != null) {
              s.subscribedChannels = List<string>(status.subscribedChannels);
            }
          }
        }
        switch (status.operation) {
          case Pubnub.OPERATIONS.PNUnsubscribeOperation: {
            if (status.affectedChannels != null) {
              const channels = new Set(status.affectedChannels);
              s.subscribedChannels = s.subscribedChannels.filter(
                (channel) => !channels.has(channel),
              );
            }
          }
        }
      });
    }
    case PubnubActions.PRESENCE_CHANGE: {
      return state.withMutations((s) => {
        s.presence = action.presence;
      });
    }
  }
  return state;
}

export const pubnubReducer: ActionReducer<PubnubStoreState, Action> = reducer as ActionReducer<
  PubnubStoreState,
  Action
>;
